"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    timeText: {
        color: function (data) { return data.color; },
    },
};
//# sourceMappingURL=time.theme.js.map